import React from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";

export default function Faq() {
  return (
    <>
      <div className="faq-parent container mx-auto px-6 py-10">
        {/* General FlexNet Overview */}
        <div className="faq-container">
          <h1>General FlexNet Overview</h1>
          <div className="card accordion-box">
            <Accordion>
              <AccordionTab header="What is FlexNet and how does it work?">
                <p>
                  FlexNet is a comprehensive connectivity solution providing
                  both 4G and 5G network capabilities for various industries.
                </p>
              </AccordionTab>
              <AccordionTab header="Who can benefit from FlexNet solutions?">
                <p>
                  FlexNet benefits businesses, industries, and enterprises
                  seeking reliable and scalable connectivity solutions.
                </p>
              </AccordionTab>
              <AccordionTab header="What industries does FlexNet cater to?">
                <p>
                  FlexNet caters to industries like manufacturing, logistics,
                  healthcare, mining, and more.
                </p>
              </AccordionTab>
              <AccordionTab header="What makes FlexNet different from other 4G/5G connectivity providers?">
                <p>
                  FlexNet stands out due to its flexible deployment models,
                  integration with edge computing, and AI-powered features.
                </p>
              </AccordionTab>
              <AccordionTab header="Can I use FlexNet for both 4G and 5G networks?">
                <p>Yes, FlexNet supports both 4G and 5G networks seamlessly.</p>
              </AccordionTab>
              <AccordionTab header="What deployment models does FlexNet offer?">
                <p>
                  FlexNet offers cloud-based, on-premises, and hybrid deployment
                  models.
                </p>
              </AccordionTab>
              <AccordionTab header="Is FlexNet suitable for small businesses?">
                <p>
                  Yes, FlexNet's flexibility and scalability make it suitable
                  for small businesses as well.
                </p>
              </AccordionTab>
            </Accordion>
          </div>
        </div>

        {/* Connectivity & Network Solutions */}
        <div className="faq-container">
          <h1>Connectivity & Network Solutions</h1>
          <div className="card accordion-box">
            <Accordion>
              <AccordionTab header="How is FlexNet deployed in an on-premises setup?">
                <p>
                  FlexNet is deployed with local servers and equipment, ensuring
                  data security and low-latency operations.
                </p>
              </AccordionTab>
              <AccordionTab header="What is the On-Prem Portable solution, and how does it work?">
                <p>
                  The On-Prem Portable solution provides a mobile network
                  solution for remote or temporary locations.
                </p>
              </AccordionTab>
              <AccordionTab header="How does FlexNet's cloud-based model work?">
                <p>
                  FlexNet’s cloud model allows network management through
                  remote, scalable infrastructure for easy deployment.
                </p>
              </AccordionTab>
              <AccordionTab header="What kind of devices are compatible with FlexNet’s network?">
                <p>
                  FlexNet supports various devices, including IoT, mobile, and
                  enterprise systems.
                </p>
              </AccordionTab>
              <AccordionTab header="How do I extend FlexNet coverage in remote areas?">
                <p>
                  FlexNet offers repeaters and portable solutions to extend
                  coverage in remote areas.
                </p>
              </AccordionTab>
              <AccordionTab header="What equipment is included with each FlexNet deployment?">
                <p>
                  FlexNet deployments include routers, antennas, and necessary
                  hardware.
                </p>
              </AccordionTab>
              <AccordionTab header="What happens if my location doesn’t have public network coverage?">
                <p>
                  FlexNet can deploy a private network in locations without
                  public network coverage.
                </p>
              </AccordionTab>
            </Accordion>
          </div>
        </div>

        {/* FlexNet Marketplace */}
        <div className="faq-container">
          <h1>FlexNet Marketplace</h1>
          <div className="card accordion-box">
            <Accordion>
              <AccordionTab header="What is the FlexNet Marketplace?">
                <p>
                  The FlexNet Marketplace is an online platform for purchasing
                  applications and devices that work with FlexNet.
                </p>
              </AccordionTab>
              <AccordionTab header="How do I access applications and devices in the marketplace?">
                <p>
                  You can access applications and devices via the FlexNet portal
                  with authorized credentials.
                </p>
              </AccordionTab>
              <AccordionTab header="Are the applications tailored for specific industries?">
                <p>
                  Yes, the applications in the marketplace are tailored to
                  industries like mining, logistics, and healthcare.
                </p>
              </AccordionTab>
              <AccordionTab header="Can I customize solutions available in the marketplace?">
                <p>
                  Yes, FlexNet offers customization of marketplace solutions to
                  meet business-specific needs.
                </p>
              </AccordionTab>
              <AccordionTab header="How are marketplace applications integrated with my existing system?">
                <p>
                  Applications are designed for seamless integration through
                  APIs with your existing infrastructure.
                </p>
              </AccordionTab>
              <AccordionTab header="How are devices in the marketplace certified for FlexNet?">
                <p>
                  All devices are tested and certified to ensure compatibility
                  with FlexNet’s network.
                </p>
              </AccordionTab>
              <AccordionTab header="Can I purchase hardware or software separately from the marketplace?">
                <p>
                  Yes, hardware and software can be purchased separately from
                  the marketplace.
                </p>
              </AccordionTab>
            </Accordion>
          </div>
        </div>
      </div>
      <h1 className="section-titles">Still Have Questions?</h1>
    </>
  );
}
